import {Route} from '@angular/router';
import {AtLeastAdminGuard, AuthGuard, NonInfluencerGuard} from '@app/_guards';
import {ProjectMonitoringComponent} from './monitoring.component';

/**
 * Project > Integration > Project Monitoring (the server's menu entry project.integration.monitor).
 * AtLeastAdminGuard asks whether the user holds 'view-project-monitoring-menu', a navigation
 * ability the server sends at sign-in (every user, today); the server's API decides what each
 * may read and do there.
 */
export const PROJECT_MONITORING_ROUTE: Route = {
  path: 'projects/:projectId/monitoring',
  component: ProjectMonitoringComponent,
  canActivate: [AuthGuard, NonInfluencerGuard, AtLeastAdminGuard],
  data: {permission: 'view-project-monitoring-menu', navTitle: 'Project Monitoring'}
};
